/// <reference types="./SchemaSpecification.d.ts" />
import { RichTextNodeType, } from '../Types.js';
export const FieldType = {
    Boolean: 'Boolean',
    Component: 'Component',
    Location: 'Location',
    Number: 'Number',
    Reference: 'Reference',
    RichText: 'RichText',
    String: 'String',
};
export const REQUIRED_RICH_TEXT_NODES = /* @__PURE__ */ (() => [
    RichTextNodeType.root,
    RichTextNodeType.paragraph,
    RichTextNodeType.text,
    RichTextNodeType.linebreak,
    RichTextNodeType.tab,
])();
export const GROUPED_RICH_TEXT_NODE_TYPES = /* @__PURE__ */ (() => [
    [RichTextNodeType.list, RichTextNodeType.listitem],
    [RichTextNodeType.code, RichTextNodeType['code-highlight']],
])();
//# sourceMappingURL=SchemaSpecification.js.map